import React from 'react';

const Gallery = () => {
  const videos = [
    { title: 'Nilsa-aplicando-latigo', url: 'https://adilo.bigcommand.com/watch/GDZaB1gg' },
    { title: 'Omar-ciclista', url: 'https://adilo.bigcommand.com/watch/PMIhl2U9' },
    { title: 'Promo-music', url: 'https://adilo.bigcommand.com/watch/mxhbBbe3' },
    { title: 'Testimonio Ricky', url: 'https://adilo.bigcommand.com/watch/4es_i3JN' },
    { title: 'Testimonio-Yalaira-Gurabo', url: 'https://adilo.bigcommand.com/watch/r13gb0XC' },
    { title: 'Testimonio-uso-lactigo', url: 'https://adilo.bigcommand.com/watch/dZ8vaSFe' },
    { title: 'Video-Guía-Para-Atletas', url: 'https://adilo.bigcommand.com/watch/py1zIQpg' },
    { title: 'Lactigo-Para-Adultos-Mayores', url: 'https://adilo.bigcommand.com/watch/BIY6qSDL' },
    { title: 'Testimonio-Lourdes-New-Jersey', url: 'https://adilo.bigcommand.com/watch/VK87F7zm' },
    { title: 'Testimonio Aplicación-rodilla', url: 'https://adilo.bigcommand.com/watch/nnzR3hNF' }
  ];

  return (
    <section id="gallery" className="section">
      <div className="container">
        <h2 className="section-title">Testimonios y Guías</h2>
        <div className="row g-4 justify-content-center">
          {videos.map((video, index) => (
            <div key={index} className="col-lg-4 col-md-4 col-sm-12">
              <div className="card h-100 shadow-lg">
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{video.title}</h5>
                  <div className="ratio ratio-vertical">
                    <iframe src={video.url} title={video.title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;